import { gsap }             from "gsap";
import { ScrollTrigger }    from "gsap/ScrollTrigger";
import videoVimeo           from "./videoVimeo";

let animVideo = {
    init() {
        if( $('body').hasClass('page-node-type-marque') ||
            $('body').hasClass('page-node-type-landing')){
            animVideo.blocVideo();
        }
    },
    blocVideo() {
        window.id3 = $('.bloc-video video').attr('id') ;
        let tlBV = gsap.timeline({
            scrollTrigger: {
                trigger: '.bloc-video',
                start: 'top top',
                end: 'bottom top',
                scrub: 1,
                pin: true,
                toggleActions : 'play none none reverse',
                markers: false,
                refreshPriority: -1
            }
        })
        tlBV.add( function(){ videoVimeo.videoPause(window.id3) }, 0);
        tlBV.to(".bloc-video .videoWrapper", {duration: 1, width: '100%', height: '100%', ease: "power1.inOut"}, 0.3);
        tlBV.to(".bloc-video .overlay", {duration: 1, opacity: 0, ease: "power1.inOut"}, 0.3);
        tlBV.add( function(){ videoVimeo.videoPlay(window.id3) }, 0.5);
        tlBV.add( function(){ videoVimeo.videoPlay(window.id3) }, 2.9);
        tlBV.add( function(){ videoVimeo.videoPause(window.id3) }, 3);
    }
}

export default animVideo;
